<template>
  <v-col class="variante-body rounded-lg px-10 py-7">
    <v-row v-for="(ipt, index) in option.valor" :key="index" class="mb-2">
      <v-col cols="12" sm="6" class="pa-0 pl-2">
        <div>
          <div v-if="ipt.tipo === 'DATA'">
            <OpcaoData
              :descricaoOpcao="ipt.descricao"
              @inputValue="ipt.descricao = $event"
              @remove="removerValor(ipt.descricao)"
            />
          </div>
          <div v-else-if="ipt.tipo === 'HORA'">
            <v-text-field
              v-model="ipt.descricao"
              v-mask="'##:##'"
              placeholder="hh:mm"
              dense
              outlined
              class="rounded-lg"
              hide-details
              solo
              prepend-inner-icon="mdi-clock"
            >
            </v-text-field>
          </div>
          <div v-else>
            <v-text-field
              v-model="ipt.descricao"
              solo
              dense
              hide-details
              outlined
              :placeholder="optionTypeLabel"
              type="text"
              class="rounded-lg elevation-0"
            >
            </v-text-field>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="2" class="pa-0 pl-2 mt-2 mt-sm-0">
        <v-text-field
          v-model="ipt.qtd_default"
          :disabled="isEdit && isDisabled(ipt.idvariacao, ipt.identificador)"
          solo
          dense
          hide-details
          outlined
          :placeholder="$t('events.event-config.quantity')"
          type="number"
          class="rounded-lg elevation-0"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3" class="pa-0 pl-2 mt-2 mt-sm-0">
        <BaseMoneyField
          v-model="ipt.preco_default"
          :disabled="isEdit && isDisabled(ipt.idvariacao, ipt.identificador)"
          solo
          dense
          hide-details
          outlined
          :placeholder="$t('events.event-config.price')"
          type="text"
          class="rounded-lg elevation-0"
        >
        </BaseMoneyField>
      </v-col>
      <v-col cols="12" sm="1" class="d-flex justify-end justify-sm-start">
        <v-tooltip bottom slot="append-outer">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="grey" dark @click="configItem(ipt)">
              mdi-cog-outline
            </v-icon>
          </template>
          <span>{{ $t("events.event-config.settings") }}</span>
        </v-tooltip>
        <v-tooltip bottom slot="append-outer">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              color="grey"
              dark
              @click="removerValor(ipt.descricao)"
            >
              mdi-close-box
            </v-icon>
          </template>
          <span>{{ $t("events.event-config.remove-variation") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="mt-5 justify-sm-end">
      <v-btn
        class="rounded-lg mr-sm-2"
        :width="!smAndUp ? '100%' : 'auto'"
        @click="adicionarValor"
      >
        {{ addVariationTitle }}
      </v-btn>
      <v-btn
        class="rounded-lg button button-bg mt-3 mt-sm-0"
        :width="!smAndUp ? '100%' : 'auto'"
        @click="criarVariaveis"
      >
        {{ newVariationTitle }}
      </v-btn>
    </v-row>
    <OptionConfigDialog
      :dialogOpcao="dialogOpcao"
      :opcaoItem="opcaoItem"
      :opcaoIndex="opcaoIndex"
      :defaultOpcaoItem="defaultOpcaoItem"
      :idx="idx"
      :optionValor="option.valor"
      @close="closeConfigItem"
      @changeVariations="criarVariaveis"
    />
  </v-col>
</template>
<script>
import OpcaoData from "@/components/produtos/gerenciar/variants/opcao-data.vue";
import OptionConfigDialog from "@/components/produtos/gerenciar/variants/OptionConfigDialog.vue";
import { v4 } from "uuid";
import { mapActions, mapGetters } from "vuex";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import displayHelpers from "../../../../mixins/breakpoints.mixins";

export default {
  name: "VariantOption",
  mixins: [displayHelpers],
  components: {
    OpcaoData,
    OptionConfigDialog,
    BaseMoneyField,
  },
  props: ["option", "idx"],
  data() {
    return {
      pronto: false,
      dialogOpcao: false,
      opcaoIndex: -1,
      errors: {
        tipo: [],
        valor: [],
      },
      opcaoItem: {
        descricao: "",
        descricao_en_us: "",
        descricao_es_es: "",
        preco_default: "",
        qtd_default: "",
        prioridade: "",
        taxa: "",
      },
      defaultOpcaoItem: {
        descricao: "",
        descricao_en_us: "",
        descricao_es_es: "",
        preco_default: "",
        qtd_default: "",
        prioridade: "",
        taxa: "",
      },
    };
  },
  computed: {
    ...mapGetters(["variations"]),
    optionType() {
      return this.option.tipo;
    },
    ticketType() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "INGRESSO"
      );
    },
    newVariationTitle() {
      return this.ticketType
        ? this.$t("events.event-config.create-ticket")
        : this.$t("events.event-config.create-variation");
    },
    addVariationTitle() {
      return this.ticketType
        ? this.$t("events.event-config.add-another-ticket")
        : this.$t("events.event-config.add-another-variation");
    },
    nameFieldLabel() {
      return this.ticketType
        ? this.$t("events.event-config.ticket-name")
        : this.$t("events.event-config.variation-name");
    },
    optionTypeLabel() {
      if (this.optionType == "DATA") {
        return "Data (Evento Recorrente)";
      } else if (this.optionType == "HORA") {
        return "Hora (Evento Recorrente)";
      } else {
        return this.nameFieldLabel;
      }
    },
    optionTypeHour() {
      return this.optionType == "HORA";
    },
    optionTypeDate() {
      return this.optionType == "DATA";
    },
    isDuplicate() {
      return this.$produtos_gerenciar.produtosAddEdit == "duplicar";
    },
    isEdit() {
      return this.$produtos_gerenciar.produtosAddEdit == "editar";
    },
    optionsObject() {
      const objects = [];
      const tipos = Array.from(
        new Set(this.option.valor.map(item => item.tipo))
      );

      tipos.forEach(tipo => {
        const object = {
          tipo: tipo || "TEXTO",
          pronto: this.pronto,
          valor: [],
        };

        this.option.valor.forEach(item => {
          if (!item.descricao) {
            this.showSnackbarError(
              this.$t("events.event-config.fill-all-fields")
            );
            return;
          }
          if (item.tipo === tipo) {
            const rest = {
              descricao: item.descricao,
              descricao_en_us: item.descricao_en_us || item.descricao,
              descricao_es_es: item.descricao_es_es || item.descricao,
              preco_default: item.preco_default || "",
              qtd_default: item.qtd_default || "",
              prioridade: item.prioridade || "",
              taxa: item.taxa || "",
            };
            const newItem = {
              ...rest,
              identificador: item.idvariacao ? "" : item.identificador || v4(),
              idvariacao: item.idvariacao || (item.identificador ? "" : v4()),
            };
            const duplicatedItem = {
              ...rest,
              identificador: v4(),
            };

            this.isDuplicate
              ? object.valor.push(duplicatedItem)
              : object.valor.push(newItem);
          }
        });

        objects.push(object);
      });
      return objects;
    },
  },
  methods: {
    ...mapActions(["fetchVariations", "showSnackbarError"]),
    removerOpcao(index) {
      this.$produtos_gerenciar.cadastro.variacoes.opcoes.splice(index, 1);
    },
    adicionarValor() {
      this.pronto = false;
      this.option.valor.push({
        descricao: "",
        tipo: "TEXTO",
        descricao_en_us: "",
        descricao_es_es: "",
        preco_default: "",
        qtd_default: "",
        prioridade: "",
        taxa: "",
        identificador: v4(),
      });
    },
    /**
     * @description Método que remove valor em opção de variação
     */
    removerValor(descricao) {
      const indexDescription = this.option.valor.findIndex(
        item => item.descricao === descricao
      );

      if (indexDescription !== -1) {
        this.option.valor.splice(indexDescription, 1);

        if (this.option.valor.length === 0) {
          this.$produtos_gerenciar.cadastro.variacoes.opcoes = [];
        }
      }
    },

    /**
     * @description Método que salva as opções criadas
     */
    criarVariaveis() {
      this.$produtos_gerenciar.removeOpcao = true;

      this.fetchVariations(this.optionsObject);
    },

    /**
     * @description Método que abre modal de edição de variação
     */
    configItem(item) {
      this.opcaoIndex = this.option.valor.indexOf(item);
      this.opcaoItem = Object.assign({}, item);
      this.dialogOpcao = true;
    },
    /**
     * @description Método que fecha modal de edição
     */
    closeConfigItem() {
      this.dialogOpcao = false;
      this.$nextTick(() => {
        this.opcaoItem = Object.assign({}, this.defaultOpcaoItem);
        this.opcaoIndex = -1;
      });
    },
    isDisabled(idvariacao, identificacao) {
      let variationId = this.variations.map(
        variation => variation.nidvariacao[0]
      );
      let hasSameId = variationId.some(item =>
        item.includes(idvariacao || identificacao)
      );

      return hasSameId;
    },
  },
  mounted() {
    this.$produtos_gerenciar.tipo_variacoes =
      this.$axios.getLocal("tipos-variacoes").data;
    if (this.isDuplicate) {
      this.fetchVariations(this.optionsObject);
    }
  },
};
</script>
<style scoped>
.variante-body {
  background-color: #f3eeee;
}

.produtos-close-variacoes-icon {
  width: 30px;
  height: 30px;
  fill: #666 !important;
  transition: all 0.2s ease;
  position: absolute;
  right: 40px;
}

.produtos-close-variacoes-icon:hover {
  cursor: pointer !important;
  fill: #fff !important;
}

.produtos-variacoes-text01 {
  align-self: flex-start;
}

.produtos-variacoes-text012 {
  align-self: flex-end;
}

.values-label {
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 2.5rem 10px 0px 10px;
  flex-direction: row;
}

.produtos-variacoes-container034 {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}

.produtos-variacoes-container04 {
  flex: 0 0 auto;
  width: 100%;
  height: 51px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.produtos-variacoes-textinput {
  width: 100%;
  height: 40px;
  border-radius: 10px;
}

.produtos-variacoes-container041 {
  flex: 0 0 auto;
  width: 50%;
  height: 10px;
  display: flex;
  align-items: flex-start;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
}

.produtos-variacoes-container042 {
  flex: 0 0 auto;
  width: 52.7%;
  height: 100px;
  display: flex;
  align-items: flex-start;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: row;
}

.produtos-variacoes-container0423 {
  flex: 0 0 auto;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  padding-top: 5px;
}

.produtos-gerenciar-navlink1 {
  color: var(--dl-color-gray-white);
  height: 51px;
  display: flex;
  border-width: 0px;
  margin-right: 10px;
  border-radius: 10px;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
}
</style>
